import type { Phase } from "../../../../../api/spark";
import { PhaseGroup } from "./PhaseGroup";
import styles from "./HighLevelNavigation.css";

/**
 * Everything the navigation subtree needs beyond the phase it renders. Bundled
 * so intermediate components hand it straight down instead of re-listing four
 * props at every level.
 */
export interface NavBag {
  currentPhaseIndex: number;
  currentStageIndex: number;
  /** Greys out phases/stages the viewer may not open — demo mode only. */
  disableSome: boolean;
  onStageClick: (phaseIndex: number, stageIndex: number) => void;
}

interface HighLevelNavigationProps {
  phases: Phase[];
  nav: NavBag;
}

export const HighLevelNavigation = ({
  phases,
  nav,
}: HighLevelNavigationProps) => (
  <div className={styles.list} id="higher-level-navigation">
    {phases.map((phase, phaseIndex) => (
      <PhaseGroup
        key={`${phase.type}-${phase.name}`}
        phase={phase}
        phaseIndex={phaseIndex}
        nav={nav}
      />
    ))}
  </div>
);
